module.exports = __webpack_public_path__ + "img/9788952116956.3155e72e.jpg";